import React from 'react';
import { observer } from 'mobx-react';
import ReportSetupFormFragment from '../ReportSetupFormFragment';
import ReportFrequencyFormFragment from '../ReportFrequencyFormFragment';
import ReportRecipientsFormFragment from '../ReportRecipientsFormFragment';
import { CleanHR } from '@awarego-ui/components';

function ReportRecurringForm({
    reportsForm,
    lists,
    usersTimeZone,
    editingReport,
    enableTags = false,
    companyId,
}) {
    const inputHasError = (input) =>
        reportsForm.$(input).error && reportsForm.$(input).error.length > 0;

    return (
        <>
            <ReportSetupFormFragment
                reportsForm={reportsForm}
                lists={lists}
                inputHasError={inputHasError}
                editingReport={editingReport}
            />
            <ReportFrequencyFormFragment
                reportsForm={reportsForm}
                inputHasError={inputHasError}
                usersTimeZone={usersTimeZone}
                editingReport={editingReport}
            />
            <CleanHR my={28} />
            <ReportRecipientsFormFragment
                inputHasError={inputHasError}
                reportsForm={reportsForm}
                editingReport={editingReport}
                enableTags={enableTags}
                companyId={companyId}
            />
        </>
    );
}

export default observer(ReportRecurringForm);
